import { BOOKING_STATUS_CODE } from 'common/constants/bookingConstants'

import type { IBooking } from 'features/Booking/interfaces/IBooking'

/**
 * A package that reached the completed list without its contract ever being signed has no
 * reachable destination: `Promotion` registers no `details` route while it waits to be
 * signed, and the signing flow no longer applies once the package has ended.
 */
export const isUnavailableLease = (booking: Pick<IBooking, 'is_promotion' | 'status_code'>) =>
  !!booking?.is_promotion && booking?.status_code === BOOKING_STATUS_CODE.WAITING_TO_SIGN
